import { ReduxAction } from '../../models'
import { Actions } from '../actions/Constants'

export const RelayReducer = (state: { [key: string]: any } = {}, action: ReduxAction): { [key: string]: any } => {
    if (action.type === Actions.Relay.Update) {
        return { ...state, [action.subject]: action.data }
    } else return state
}
